import { Module } from "@/constants";
import type { Permission } from "@/types/permission";
import {
  moduleCustomPermissions,
  modulePermissionRules,
} from "@/types/permissions";

const basePermissionDefaults = {
  can_read: false,
  can_create: false,
  can_export: false,
  can_update: false,
  can_delete: false,
} as const;

/**
 * Merges the flat account permission list into one boolean map for a module.
 */
export function mergeModulePermissions(
  module: Module,
  accountPermissions: Permission[],
): Record<string, boolean> {
  const modulePrefix = module.replace(/-/g, "_");

  const codesForModule = accountPermissions.filter((p) =>
    p.code.startsWith(`${modulePrefix}_`),
  );

  const flags: Record<string, boolean> = {
    ...basePermissionDefaults,
  };

  const customKeys = moduleCustomPermissions[module];
  if (customKeys) {
    for (const key of customKeys) {
      flags[key] = false;
    }
  }

  for (const permission of codesForModule) {
    const actionSuffix = permission.code.split(`${modulePrefix}_`)[1];
    if (!actionSuffix) continue;

    const canKey = `can_${actionSuffix}`;
    if (canKey in flags) {
      flags[canKey] = true;
    }
    flags[permission.code] = true;
  }

  const rules = modulePermissionRules[module];
  if (rules) {
    for (const [baseKey, sourceCodes] of Object.entries(rules)) {
      if (sourceCodes?.some((code) => flags[code])) {
        flags[baseKey] = true;
      }
    }
  }

  return flags;
}
